import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";

type DeskLookup = { userId: string; brand: string | null };

export function useSupportDesk(enabled = true) {
  const { user } = useAuth();
  const userId = user?.id ?? null;
  const [lookup, setLookup] = useState<DeskLookup | null>(null);

  useEffect(() => {
    if (!enabled || !userId || lookup?.userId === userId) return;
    let cancelled = false;
    supabase.rpc("support_desk_brand").then(({ data }) => {
      if (cancelled) return;
      setLookup({ userId, brand: typeof data === "string" && data ? data : null });
    });
    return () => {
      cancelled = true;
    };
  }, [enabled, userId, lookup?.userId]);

  const resolved = !!userId && lookup?.userId === userId;
  const supportDeskBrand = enabled && resolved ? lookup?.brand ?? null : null;

  return {
    supportDeskBrand,
    isSupportDeskAgent: !!supportDeskBrand,
    loading: enabled && !!userId && !resolved,
  };
}
